import { render } from "./Login.vue?vue&type=template&id=2225c05a&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=2225c05a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2225c05a"

export default script